"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFetchGroups = useFetchGroups;
exports.useUpdateRelatedGroups = exports.useGroupReviews = exports.useGroupAverageRating = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _utils = require("../../../utils");
var _react = require("react");
var _types = require("../../../types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var useGroupReviews = function useGroupReviews(group) {
  var _useFetch = (0, _utils.useFetch)((0, _utils.getGroupReviewsUrl)(group.id, (0, _momentTimezone.default)(group.createdAt).utc().format(), (0, _momentTimezone.default)().utc().format()), []),
    data = _useFetch.data,
    loading = _useFetch.loading,
    refetch = _useFetch.refetch;
  return {
    reviews: data,
    loadingReviews: loading,
    refetchReviews: refetch
  };
};
exports.useGroupReviews = useGroupReviews;
var useGroupAverageRating = function useGroupAverageRating(clinician) {
  var _useFetch2 = (0, _utils.useFetch)((0, _utils.getGroupAverageRatingUrl)(clinician.id), {}),
    data = _useFetch2.data,
    loading = _useFetch2.loading;
  return {
    averageRating: data,
    loadingAverageRating: loading
  };
};
exports.useGroupAverageRating = useGroupAverageRating;
function useFetchGroups() {
  var _useFetch3 = (0, _utils.useFetch)((0, _utils.getGroupUrl)(), []),
    data = _useFetch3.data,
    loading = _useFetch3.loading;
  var groups = (0, _react.useMemo)(function () {
    return data.reduce(function (arr, group) {
      if (group.status === _types.GroupStatus.Active) {
        arr.push((0, _lodash.pick)(group, ['id', 'name']));
      }
      return arr;
    }, []);
  }, [data]);
  return {
    groups: groups,
    loadingGroups: loading
  };
}
var useUpdateRelatedGroups = function useUpdateRelatedGroups() {
  return (0, _utils.useUpdate)({
    update: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var groupId, values;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                groupId = _ref.groupId, values = _ref.values;
                _context.next = 3;
                return _utils.api.put((0, _utils.getUpdateRelatedGroupsUrl)(groupId), values);
              case 3:
                _utils.toast.success({
                  title: 'Successfully updated related groups!'
                });
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function update(_x) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
  });
};
exports.useUpdateRelatedGroups = useUpdateRelatedGroups;